export default Object.freeze({
  ADMIN: 'admin',
  MEMBER: 'team_member',
});
